import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthCard } from "@/components/auth/AuthCard";
import { api, apiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(apiError(err, "Richiesta non riuscita, riprova"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthCard testId="forgot-password-card" title="Password dimenticata" subtitle="Ti mandiamo un collegamento per sceglierne una nuova">
      {sent ? (
        <div data-testid="forgot-password-sent" className="flex gap-3 rounded-xl bg-emerald-50 p-4 text-sm text-emerald-900">
          <MailCheck className="h-5 w-5 shrink-0" />
          <p>Se <strong>{email}</strong> è tra gli utenti autorizzati, riceverai a breve un'email con il collegamento. Controlla anche lo spam. Il collegamento vale 60 minuti.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="forgot-email" className="text-xs font-medium text-slate-600">Email del tuo account</Label>
            <Input id="forgot-email" data-testid="forgot-email-input" type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 rounded-xl" />
          </div>
          {error && <p data-testid="forgot-error" className="rounded-lg bg-rose-50 px-3 py-2 text-sm text-rose-700">{error}</p>}
          <Button type="submit" data-testid="forgot-submit-btn" disabled={busy} className="h-11 w-full gap-2 rounded-xl bg-emerald-600 hover:bg-emerald-700">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Invia collegamento
          </Button>
        </form>
      )}
      <Link to="/login" data-testid="back-to-login-link" className="block text-center text-sm font-medium text-slate-600 hover:text-slate-900">Torna all'accesso</Link>
    </AuthCard>
  );
}
